<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <p class="mt-2">Loading proforma invoice details...</p>
    </div>

    <div v-else-if="!order" class="text-center py-4 text-grey">
      No proforma invoice data found
    </div>

    <div v-else class="pi-preview">
      <div v-if="order.supplier" class="supplier-header">
        <h1>{{ order.supplier.name }}</h1>
      </div>

      <h2 class="report-title">PROFORMA INVOICE</h2>

      <div class="master-box">
        <v-row>
          <v-col cols="6">
            <table class="pi-table">
              <tbody>
                <tr>
                  <td><strong>PI NO.</strong></td>
                  <td>{{ order.pi_no || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <div class="boxed-text">
              <strong>EXPORTER/SELLER:</strong><br>
              <span>Shenzhen Caiju Tianxia Printing and Tranding Co. Ltd.</span><br>
              <span>Office Address: 502 Yayi Building, No. 68 Dongchang Road, Dongxiao community, Dongxiao Street, Luohu District, Shenzhen.</span>
              <span>TEL: +8615014141131</span>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="boxed-text">
              <p>EXPORTER'S LC ADVISING BANK NAME, BRANCH &amp; ADDRESS:</p>
              <p>{{ order.bank?.name }}</p>
              <p>ADD: {{ order.bank?.address }}</p>
              <p>ACCOUNT NO: {{ order.bank?.account_no }}</p>
              <p>SWIFT CODE: {{ order.bank?.swift_code }}</p>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <table class="pi-table">
              <tbody>
                <tr>
                  <td><strong>Vehicle/ Flight No.</strong></td>
                  <td>By Sea</td>
                </tr>
                <tr>
                  <td><strong>Port Of Loading</strong></td>
                  <td>{{ order.loading_port?.name }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="6">
            <table class="pi-table">
              <tbody>
                <tr>
                  <td><strong>Port of Discharge</strong></td>
                  <td>{{ order.discharge_port?.name }}</td>
                </tr>
                <tr>
                  <td><strong>Final Destination</strong></td>
                  <td>{{ order.discharge_port?.name }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <table class="pi-table">
              <tbody>
                <tr>
                  <td><strong>Country of origin good:</strong></td>
                  <td>China</td>
                </tr>
                <tr>
                  <td><strong>Country of Final Destination</strong></td>
                  <td>Bangladesh</td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="6">
            <table class="pi-table payment-term-table">
              <tbody>
                <tr>
                  <td>{{ order.payment_term?.name }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </div>

      <table class="details-table">
        <thead>
          <tr>
            <th style="width: 5%;">SL. NO.</th>
            <th>DESCRIPTION OF GOODS</th>
            <th style="width: 10%;">H.S. CODE</th>
            <th style="width: 12%;">IN QUANTITY</th>
            <th style="width: 10%;">RATE ({{ order.currency?.code }} {{ order.currency?.symbol }})</th>
            <th style="width: 12%;">AMOUNT ({{ order.currency?.code }} {{ order.currency?.symbol }})</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in order.details || []" :key="row.id || index">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">{{ row.product?.name }}</td>
            <td class="text-center">{{ row.hs_code }}</td>
            <td class="text-center">{{ row.quantity }} KGS</td>
            <td class="text-right">{{ row.rate }}</td>
            <td class="text-right">{{ row.amount }}</td>
          </tr>
          <tr v-if="!order.details?.length">
            <td colspan="6" class="text-center text-grey">No items found</td>
          </tr>
          <tr>
            <td colspan="3" class="text-right"><strong>TOTAL COST VALUE</strong></td>
            <td></td>
            <td></td>
            <td class="text-right"><strong>{{ order.total_amount }}</strong></td>
          </tr>
        </tbody>
      </table>

      <table class="terms-table">
        <tbody>
          <tr>
            <td><strong>In Words:</strong> {{ convertNumberToWords(order.total_amount) }}</td>
          </tr>
          <tr>
            <td class="terms-content">{{ order.terms_and_condition }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatDateView } from "@/plugins/helpers";
import convertNumberToWords from "@/plugins/numberToWord";
import { toast } from "vue3-toastify";

export default {
  name: "LcImportProformaInvoiceDetailsTable",

  data() {
    return {
      loading: false,
      order: null,
    };
  },

  methods: {
    formatDateView,
    convertNumberToWords,

    loadDetails() {
      const id = this.$route.query.referenceable_id || this.$route.params.id;
      if (!id) return;

      this.loading = true;
      this.$store.dispatch("getLcImportPiById", id)
        .then((response) => {
          this.order = response || null;
        })
        .catch((error) => {
          this.order = null;
          toast.error(error.response?.data?.message || "Failed to load proforma invoice details");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.loadDetails();
  },
};
</script>

<style scoped>
.pi-preview {
  font-size: 12px;
  color: #000;
}

.supplier-header {
  margin-bottom: 20px;
  padding: 12px 0;
  border-bottom: 2px solid #eee;
  text-align: center;
}

.supplier-header h1 {
  font-size: 20px;
}

.report-title {
  margin: 16px 0;
  text-align: center;
  font-size: 20px;
}

.master-box {
  margin-bottom: 16px;
}

.pi-table,
.details-table,
.terms-table {
  width: 100%;
  border-collapse: collapse;
}

.pi-table td,
.details-table th,
.details-table td,
.terms-table td {
  border: 1px solid #000;
  padding: 5px;
}

.pi-table td:first-child {
  width: 50%;
}

.boxed-text {
  min-height: 80px;
  padding: 6px;
  border: 1px solid #000;
  font-size: 11px;
  font-weight: bold;
}

.boxed-text p {
  margin: 0;
}

.payment-term-table,
.payment-term-table tbody,
.payment-term-table tr,
.payment-term-table td {
  height: 100%;
}

.payment-term-table td {
  text-align: center;
  vertical-align: middle;
}

.details-table {
  margin-top: 12px;
  font-size: 12px;
}

.details-table th {
  background: #e0e0e0;
  text-align: center;
}

.terms-table {
  margin-top: 12px;
}

.terms-content {
  min-height: 80px;
  vertical-align: top;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.signature-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 36px;
}

.signature-box {
  width: 50%;
  text-align: center;
  font-size: 12px;
}

.signature-line {
  height: 30px;
  margin-bottom: 8px;
  border-bottom: 1px solid #000;
}
</style>
